import dayjsTZ from "../../../../utils/dayjs";
import { monthBoundsInTz } from "../../../../utils/timezone/dayBounds";
import { getCompanyTimezone } from "../../../../utils/timezone/teamTimezone";

/** True if a leave request overlaps [rangeStart, rangeEnd] (dayjs or ms). */
export function leaveOverlapsRange(request, rangeStart, rangeEnd) {
  const period = request?.requestPeriod;
  if (!period?.length) return false;
  const start = dayjsTZ(rangeStart).startOf("day").valueOf();
  const end = dayjsTZ(rangeEnd).endOf("day").valueOf();
  const leaveStart = dayjsTZ(period[0]).startOf("day").valueOf();
  const leaveEnd = dayjsTZ(period.at(-1)).endOf("day").valueOf();
  return leaveStart <= end && leaveEnd >= start;
}

export function filterLeaveByRange(leave, rangeStart, rangeEnd) {
  return (leave || []).filter((r) =>
    leaveOverlapsRange(r, rangeStart, rangeEnd)
  );
}

export function monthRangeFromDayjs(monthDayjs) {
  const { startMs, endMs } = monthBoundsInTz(
    getCompanyTimezone(),
    monthDayjs || undefined
  );
  return {
    start: dayjsTZ(startMs),
    end: dayjsTZ(endMs),
  };
}

/** Full calendar year of the selected month (company TZ). */
export function yearRangeFromDayjs(monthDayjs) {
  const m = dayjsTZ(monthDayjs || undefined);
  return {
    start: m.startOf("year"),
    end: m.endOf("year"),
    year: m.year(),
  };
}

/** userSubs that have at least one leave overlapping the range. */
export function userSubsWithLeaveInRange(leave, rangeStart, rangeEnd) {
  const set = new Set();
  filterLeaveByRange(leave, rangeStart, rangeEnd).forEach((r) => {
    if (r?.userSub) set.add(r.userSub);
  });
  return set;
}
